import { Injectable } from "@angular/core";

@Injectable()
export class SharedMaskService {
    //public maskPhoneNumber: string = 'YYYYYYYYYY';
    //public ruleNumbersOnly: { [key: string]: RegExp } = { "Y": /[0-9]/ };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/shared/shared-masks.service.ts